/** @jsx jsx */
import { jsx } from '@emotion/core'

import Logo from '../../components/logo'
import Section from '../../components/section'
import { Form } from 'antd'
import useScreen from '../../hooks/use-screen'
import Navigation from '../../components/navigation'
import useTranslate from '../../hooks/use-translate'
import InputReferenceCode from '../../components/input-reference-code'
import { useRecoilValue } from 'recoil'
import { clientState } from 'src/state'

const ScreenReferenceCode = () => {
  const { form, storedValue } = useScreen()

  const client = useRecoilValue(clientState)

  const { t } = useTranslate({
    clientData: {
      ...client,
    },
  })

  return (
    <Form
      autoComplete="off"
      form={form}
      layout="vertical"
      initialValues={storedValue}
    >
      <Section>
        <Logo />
      </Section>
      <Section>
        <div className='text-xs mb-4' style={{ fontSize: '12px' }}>
          <strong>Varmt tack för att ni har använt Kind Files!</strong><br />
          <br />
          Vi är glada att ni är med på vår resa! Vi har nu vidareutvecklat systemet och lanserat Optirem – en branschanpassad plattform för säker och effektiv digital remisshantering mellan optiker och ögonkliniker. Optirem är framtagen tillsammans med <strong>Optikbranschen</strong> med målet att bli ett gemensamt system för hela branschen. Alla Sveriges optikkedjor och fristående butiker ska enkelt kunna skicka remisser till valfri ögonklinik.<br />
          <br />
          <strong>Kind files stängs ner den 1 augusti.</strong><br />
          <br />
          Har du frågor eller funderingar eller ännu inte blivit ansluten till Optirem? Hör av dig till <a href="mailto:annica@kind.app">annica@kind.app</a>.<br />
          <br />
          <strong>Vänliga hälsningar,<br />
            Optiremgänget</strong>
        </div>
      </Section>
      <Section>
        <div>{t('SCREEN_REFERENCE_CODE_LINE_1')}</div>
      </Section>
      <Section>
        <InputReferenceCode />
      </Section>
      <Navigation form={form} />
    </Form>
  )
}

export default ScreenReferenceCode
